import mk from "../el-ui-locales/mk";

export default {
  ...mk,
  
  At: 'На',
  select_team: "Изберете тим",
  type_of_preview: "Тип на преглед",
  detail_view: "Детален преглед",
  summary_view: "Збирен преглед",

  // presence drawer
  select_an_employee: "Одберете вработен",
  enter_date: "Внесете дата",
  presence_type: "Тип на присуство",
  strict_time: "Фиксно време",
  select_work_shift: "Одберете смена",
  until_the_end_of_the_week: "до крајот на неделата",
  until_the_end_of_the_month: "до крајот на месецот",
  edit_schedule: "Промена на закажано време",
  required: "Задолжително",
  sliding_time: "Клизно време",
  final_start_time: "Крајно време за почеток",
  number_of_working_hours: "Број на работни часови",

  are_you_sure: "Дали сте сигурни?",
  confirm: "Потврди",
  are_you_sure_update_presence: "Дали сте сигурни дека сакате да го ажурирате ова присуство?",
  yes_update_it: "Да, ажурирај го",
  are_you_sure_create_presence: "Дали сте сигурни дека сакате да го креирате ова присуство?",
  yes_create_it: "Да, креирај го",
  are_you_sure_delete_presence: "Дали сте сигурни дека сакате да го избришете ова присуство?",
  yes_delete_it: "Да, избришете го",
  are_you_sure_create_scheduler: "Дали сте сигурни дека сакате да ја креирате оваа смена/и?",
  yes_create_scheduler: "Да, креирај ја/ги",

  // expand button texts in weekly totals
  view_detail_work: "Погледни повеќе",
  hide_detail_work: "Сокриј повеќе",

  // navigation bar
  dashboard: "Дома",
  presence: "Присуство",
  calendar: "Календар",
  reports: "Извештаи",
  shift_reports: "Извештај за смени",
  my_presence: "Мое присуство",
  my_calendar: "Мој календар",
  my_profile: "Moj Профил",
  hi: "Здраво",
  logout: "Одјави се",
  // footer
  made_by: "изработено од",
  version: "Верзија",
  cookie_policy: "Политика за користење колачиња",
  privacy_policy: "Политика за приватност",
  // tables
  no_data_available: "Нема достапни податоци",
  showing_entries: "Се прикажуваат {from} до {to} од {total} записи",
  go_to: "Oди до",
  page_size: "{size}/страна",
  person1: "Лице",
  start_date: "Почетен датум",
  department: "Oддел",
  team: "Тим",
  type_of_absence: "Вид на отсуство",
  requested_period: "Баран период",
  requested_days: "Барани денови",
  submitted_at: "Поднесено на",
  period: "Период",
  years_in_company: "Години во фирмата",
  pending_absence_requests: "Барања за отсуство",
  pending_absence_request: "Барање за отсуство",
  todays_absences: "Денешни отсуства",
  todays_absence: "Денешно отсуство",
  start_tomorrow_absences: "Отсуства кои започнуваат утре",
  start_tomorrow_absence: "Отсуство кое започнува утре",
  upcoming_work_anniversary: "Претстојна годишнина во фирмата",
  upcoming_work_birthdays: "Претстојни родендени",

  // Presence
  success: "Успешно",
  search: "Пребарај",
  your_input_was_saved_successfully: "Вашиот внес беше успешно зачуван",
  //**********from absent my_presence.php**********//
  today_presence: "Присуство за денес",
  clock_in: "Работа почеток",
  clock_out: "Работа крај",
  break_start: "Пауза почеток",
  break_stop: "Пауза крај",
  private_exit_start: "Излегување почеток",
  private_exit_stop: "Излегување крај",
  From: "Од",
  To: "До",
  monday: "Понеделник",
  tuesday: "Вторник",
  wednesday: "Среда",
  thursday: "Четврток",
  friday: "Петок",
  saturday: "Сабота",
  sunday: "Недела",
  paid_break: "Пауза",
  absence: "Отсуство",
  total_regular_time: "Вкупно редовно време",
  private_exit: "Излегување",
  per_page: "По страница",
  weekly_presence: "Присуство во тек на седмица",
  prev_week: "Претходна",
  week: "Седмица",
  next_week: "Следна",
  no_data: "Нема податок",
  presence_history: "Историја на присуство",
  cancel: "Откажи",
  cancelled: "Откажано!",
  field_work_start: "Теренска работа почеток",
  field_work_stop: "Теренска работа крај",
  holiday: "Празник",
  unauth_absence: "Неовластено отсуство",
  scheduled_time: "Закажано време",
  //--------from absent presence.php--------//
  work: "Работа",
  break: "Пауза",
  field_work: "Теренска работа",
  create: "Креирај",
  update: "Ажурирај",
  delete: "Избриши",
  close: "Затвори",
  save_changes: "Зачувајте ги промените",
  monday_short: "Пон",
  tuesday_short: "Вто",
  wednesday_short: "Сре",
  thursday_short: "Чет",
  friday_short: "Пет",
  saturday_short: "Саб",
  sunday_short: "Нед",
  updated_end_time: "Ажурирано<br>време на завршување",
  edit_presence: "Промена на присуства",
  person: "Личност",
  date: "Дата",
  type: "Тип на присуство",
  action: "Дејство",
  updated_start_time: "Ажурирано<br>време на започнување",
  prev_start_time: "Претходно<br>време на започнување",
  previous_start_time: "Претходно време на започнување",
  prev_end_time: "Претходно<br>време на завршување",
  previous_end_time: "Претходно време на завршување",
  duration: "Времетраење",
  last_comment: "Последен коментар",
  last_updated_by: "Последно ажурирање од",
  last_updated_at: "Последно ажурирање на",
  employee: "Вработен",
  select_time: "Избери време",
  comment: "Коментар",
  holiday: "Празник",
  total_for: "Вкупно за",
  comment_for_this_presence: "Коментар за ова присуство",
  updated_from_overlapped_presence: "Ажурирано од преклопено присуство",
  deleted_from_overlapped_presence: "Избришано од преклопено присуство",
  reason_for_updating: "Причина за ажурирање",
  max_length_is_250_characters: "Максималната должина е 250 знаци.",
  work_shift: "Смена",
  rest_day: "Неделен одмор",
  presence_on_rest_day: "Присуство за време на неделен одмор",
  selected_day: "избраниот ден",
  schedule_for: "Закажи за",
  nothing_selected: "Ништо не е одбрано",
  at: "На:",
  logged_at: "Забележано на:",
  shift_name: "Име на смена:",
  shift_start: "Почеток на смена:",
  shift_end: "Крај на смена:",
  custom: "Произволна",
  presence_on_holiday: "Присуство за време на празник",
  presence_on_absence: "Присуство за време на отсуство",
  break_on_holiday: "Платена пауза за време на празник",
  break_on_absence: "Платена пауза за време на отсуство",
  field_work_on_holiday: "Теренска работа за време на празник",
  field_work_on_absence: "Теренска работа за време на отсуство",
  presence_on_rest_day: "Присуство за време на неделен одмор",
  field_work_on_rest_day: "Теренска работа за време на неделен одмор",
  break_on_rest_day: "Платена пауза за време на неделен одмор",
  presence_on_night_work: "Присуство за време на ноќна работа",
  field_work_on_night_work: "Теренска работа за време на ноќна работа",
  break_on_night_work: "Платена пауза за време на ноќна работа",
  exceeded_break: "Пречекорена пауза",
  overtime_work: "Прекувремена работа",
  unpaid_absence: "Неплатено отсуство",
  description: "Опис",
  weekly_total_time: "Неделно вкупно време",
  no_results_found_matching_your_search: "Не се пронајдени резултати кои се совпаѓаат со вашето пребарување",
  start: "Почеток",
  end: "Крај",
  // end of presence
  // my calendar
  schedule_vacation_days: "Закажете денови за одмор",
  schedule_vacation_modal:
    "Кликнете за почеток и за крајниот датум на календарот",
  ok: "Ок",
  remaining: "Преостанати",
  pending: "Во очекување",
  used: "Искористени",
  period_of_usage: "Период за користење",
  calculation_from: "Пресметка од",
  to: "до",
  from: "од",
  of: "на",
  entries: "записи",
  showing: "Се прикажува",
  create_period: "Кликнете на уште еден датум за да создадете период",
  period: "Период",
  create_absence: "Креирај барање",
  employees: "Вработени",
  type_of_leave: "Тип на отсуство",
  personal_days_type: "Тип на персонални денови",
  select_type_of_leave: "Одберете тип на отсуство",
  type_of_personal_days: "Одберете тип на персонални денови",
  comment: "Коментар",
  absence_declied: "Отсуството беше успешно одбиено",
  file_uploaded: "Датотеката е успешно закачена",
  upload_absence_doc: "Поставете документ за отсуство",
  attach_doc: "Прикачи документ",
  choose_files: "Изберете Датотеки",
  no_file_chosen: "Не е избрана датотека",
  pdf_size: "PDF документ не смее да биде поголем од 1 МБ",
  files_allowed: "Само PDF, JPG, JPEG датотеки се дозволени",
  size_of_file: "Една датотека JPG, JPEG не треба да биде поголема од 10 MB",
  max_allowed_files: "Максимално дозволени датотеки е ",
  file_limit_exceeded:
    "Ограничувањето е {fileLimit} датотеки. Може да изберете уште {remainingFiles} датотеки.",
  submitting: "Поднесување ...",
  submit: "Поднеси",
  saving: "Зачувување ...",
  save_file: "Зачувај датотека",
  pdf_file_not_exceed: "Големината на PDF-датотеката не треба да надминува ",
  img_file_not_exceed: "Големината на слика не треба да надминува ",
  my_absence_logs_title: "Мои отсуства",
  requested_period: "Побаран период",
  requested_days: "Побарани денови",
  name_of_vacation: "Назив на годишен одмор",
  updated_at: "Обновено на",
  status: "Статус",
  action: "Дејство",
  search: "Пребарај",
  no_data_available: "Нема достапни податоци",
  submitted_by: "Поднесен од:",
  approved_by: "Одобрено од:",
  declined_by: "Одбиено од:",
  pending_approval_by: "Во очекување на одобрување од:",
  on: "На",
  at: "Во",
  comment_presence: "Коментар за ова присуство од:",
  approve: "Одобри",
  approved: "Одобрено",
  decline:"Одбиј",
  declined: "Одбиено",
  upload_files: "Прикачи датотеки",
  download_files: "Симни датотеки",
  decline_absence_request: "Дали сте сигурни дека сакате да го одбиете <br> ова барање за отсуство?",
  approve_absence_request: "Дали сте сигурни дека сакате да го <br> одобрите ова барање за отсуство?",
  decline_rest_day_request: "Дали сте сигурни дека сакате да го <br> одбиете овој неделен одмор?",
  write_reason: "Напишите ја причината за одбивање",
  decline_it: "Да, одбијте го!",
  approve_it: "Да, одобрете го!",
  vacation: "Одмор",
  presonal_days: "Платено отсуство",
  sick_leave: "Боледување",
  business_trip: "Бизнис патување",
  work_from_home: "Работа од дома",
  extra_days: "Дополнителни денови",
  switched_day: "Заменет ден",
  paid_patental_leave: "Платено породилно отсуство",
  unpaid_patental_leave: "Неплатено породилно отсуство",
  unpaid_leave: "Неплатено отсуство",
  rest_day: "Неделен одмор",
  marriage: "За стапување во брак",
  child_marriage: "За стапување во брак на деца",
  adoption_child: "За раѓање или посвојување на дете",
  death_spouse_child: "За смрт на сопружник или дете",
  death_parent_brother_sister: "За смрт на родител, брат, сестра",
  death_parent_spouse: "За смрт на родител на сопружник",
  death_grandfather_grandmother: "За смрт на дедо или баба",
  needs_of_employer:
    "За полагање на стручен испит или друг испит за потребите на работодавачот",
  natural_disasters: "За елементарни непогоди",
  moving_family_from_one_to_another_place:
    "За селидба на семејството од едно на друго место",
  moving_family_to_the_same_place: "За селидба на семејството во исто место",
  you_get_num_days: ", добивате {n} ден. | , добивате {n} денови.",
  public_holiday: "Државен празник",
  holiday: "Празник",
  profile_settings: "Поставки за профилот",
  update_picture: "Промена на слика",
  change_password: "Промена на лозинка",
  email_address: "Емаил адреса",
  full_name: "Име и презиме",
  full_name_in_docs: "Име и презиме во документи",
  display_job_position: "Работна позиција",
  job_position_in_docs: "Работна позиција во документи",
  local_language: "Enter with your local language.", // still not using
  birthday: "Роденден",
  phone_no: "Телефонски број",
  nationality: "Националност",
  religion: "Религија",
  employment_start_date: "Датум на вработување",
  country: "Држава",
  pick_date: "Изберете датум",
  symbol_placeholder: "+xx xxx xxx xxxx",
  select: "Изберете",
  pick_employment_date: "Изберете датум за вработување",
  save_changes: "Зачувајте ги промените",
  reset: "Ресетирај",
  // my calendar end
  // team leader calendar
  absence_type: "Тип на отсуство",
  select_an_employee:"Одберете вработен",
  absence_requests_for_team:"Барања за отсуство за тим",
  person2:"Лице",
  use_period:"Период за користење:",
  remaining_days: "Преостанати денови",
  pending_days:"Денови на одобрување",
  used_days: "Искористени денови",
  no_vacations_in_this_period_for_this_user: "Во овој период нема правила за одмор за овој корисник",
  info: "Ниту една акција не е достапна откако ќе се одбие барањето",
  info_waiting_approval:"Се чека на одобрување од",
  pending_approval: "На одобрување",
  decline_approval: "Одбиј",
  approved_absence: "Одобрени",
  declined_approval: "Одбиени",
  permissions_to_perform_any_actions:"Немате дозвола да извршувате какви било дејства",
  
  // team leader calendar end
  // Gm and sysadmin calendar start
  edit_comment: "Промена на коментар",
  comment_required: "Полето коментар е задолжително",
  comment_successfully_updated: "Коментарот е успешно променет",
  edit_comment: "Промена на коментар",
  // Gm and sysadmin calendar end
  // department leader start
  department: "Оддел",
  // department leader end
  // Teams start
  teams: "Тимови",
  team_lead: "Tим лидер",
  add_team: "Додади Тим",
  team_name: "Име на тим",
  team_members: "Членови на тимот",
  team_successfully_created: "Успешно креиран тим",
  team_successfully_deleted: "Тимот беше успешно избришан",
  delete_this_team: "Дали сте сигурни дека сакате да го избришете овој тим?",
  not_be_able_to_revert: "Вие нема да можете да го вратите ова!",
  yes_decline_it: "Да, избришете го!",
  select_department: "Одберете оддел",
  team_name_required: "Име на тим е задолжително",
  select_an_option: "Изберете опција",
  department_required: "Оддел е задолжително",
  team_lead_required: "Тим лидер треба да биде селектиран",
  create_team: "Креирај Нов Тим",
  edit_team: "Промена на тимот",
  team_successfully_updated: "Успешно променет тим",
  team_successfully_approved: "Успешно променет тим",
  team_successfully_declined: "Успешно променет тим",
  pending_requests: "При промена на одговорните лица, сите барања за отсуства мораат да бидат одобрени или одбиени",
  approve_all: "Одобри ги сите",
  decline_all: "Одбиј ги сите",
  approve_requests: "Дали сте сигурни дека сакате да ги одобрите сите барања?",
  yes_approve_all: "Да, одобри ги сите",
  decline_requests: "Дали сте сигурни дека сакате да ги одбиете сите барања?",
  yes_decline_all: "Да, одбиј ги сите",
  // Teams end
  // Gates start
  gates: "Влезови",
  number_of_devices: "Број на уреди",
  name: "Име",
  // Gates end
   // Settings start
  company_settings: "Подесувања за фирмата",
  company_language: "Јазик на компанијата:",
  show_qr_code_my_presence_page: 'Прикажете го QR кодот на страната "Мое Присуство"',
  enable_disable_two_factor_via_email: "Овозможи/оневозможи автентикација со два фактори преку е-пошта",
  use_pass_reset_3_months: "Задолжителна промена на лозинка секои 3 месеци.",
  enable_saving_images: "Овозможи зачувување на слики.",
  min_days_before_vacation_request: "Минимум денови пред барање за одмор:",
  disable_emails_for_gm: "Оневозможи е-пошта за генерален менаџер",
  disable_emails_for_dm: "Оневозможи е-пошта за менаџер на оддел",
  disable_emails_for_chairman: "Оневозможи е-пошта за претседател",
  allow_approval_for_absence_req: "Овозможи одобрување на барањата за отсуства:",
  general_manager: "Генерален менаџер",
  human_resources: "Човечки ресурси",
  department_lead: "Менаџер на оддел",
  allways_show_saturday: "Секогаш прикажувај сабота",
  allways_show_sunday: "Секогаш прикажувај недела",
  add_shift: "Додади смена",
  company_timezone: "Временска зона на компанијата:",
  show_presence_history_for_tm: "Прикажи историја на присуства за член на тим",
  gm_can_schedule_vacation_in_the_past: "Генерален менаџер може да закажува одмор во минатото",
  sysadmin_can_schedule_vacation_in_the_past: "Систем администратор може да закажува одмор во минатото",
  hr_can_schedule_vacation_in_the_past: "Човечки ресурси може да закажува одмор во минатото",
  dl_can_schedule_vacation_in_the_past: "Менаџер на оддел може да закажува одмор во минатото",
  tl_can_schedule_vacation_in_the_past: "Тим лидер може да закажува одмор во минатото",
  dm_can_schedule_work_time_and_rest_days: "Менаџер на оддел може да закажува работно време и неделен одмор за себе",
  tl_can_schedule_work_time_and_rest_days: "Тим лидер може да закажува работно време и неделен одмор за себе",
  absence_will_be_approved_by: "Барањата за отсуства ќе бидат одобрувани од:",
  start_time_rounding_range_margin: "Маргина за заокружување на фиксно почетно време:",
  end_time_rounding_range_margin: "Маргина за заокружување на фиксно крајно време:",
  flexible_working_hours_margin: "Маргина за заокружување на флексибилно работно време:",
  enable_night_work: "Овозможи ноќна работа",
  define_period_for_logging_working_hours: "Дефинирајте период за евидентирање на работното време",
  night_work_start_time: "Почеток на ноќна работа",
  night_work_end_time: "Крај на ноќна работа",
  logging_period_start_time: "Почеток на период за евиденција",
  logging_period_end_time: "Крај на период за евиденција",
  night_work_is_turned_on_please_enter_a_night_work_period: "Ноќната работа е вклучена, ве молиме внесете период за ноќната работа!",
  period_for_logging_work_hours_is_turned_on_please_select_work_hours_period: "Периодот за евидентирање на работното време е вклучен, ве молиме изберете период на работно време!",
  company_settings_successfully_updated: "Подесувањата на компанијата успешно се ажурирани",
  are_you_sure_want_perform_this_action: "Дали сте сигурни за извршување на оваа акција?",
  and: "И",
  or: "ИЛИ", 
  end_time_greater_than_start_time: "Крајното време мора да биде поголемо од почетното време за периодот на евидентирање.",
  enter_shift_name: "Внесете име на смена",
  select_timezone: "Изберете временска зона",
  // Settings End
  // NonRoundedPresenceReports Start
  non_rounded_presence_reports: "Незаокружени извештаи за присуство",
  // NonRoundedPresenceReports End
  // Sentice Start
  company_sentice: "Компанија:",
  report_prefix: "Извештај",
  sentice_report: "Извештај за Sentice клиенти",
  // Sentice End
  // Avatar Tab
  upload_or_drop_picture:
    "Кликнете овде за да прикачите слика или повлечете ја сликата.",
  image_allowed: "Само датотеки со слики се дозволени за поставување", //still not using
  image_is_uploaded: "Сликата е поставена",
  // Password Tab
  password_updated_successfully: "Лозинката е успешно ажурирана",
  password_rules:
    "Лозинката треба да биде составена од комбинација на најмалку осум алфанумерички карактери букви (мали и големи), симболи, броеви и интерпукциски знаци.",
  new_password: "Нова лозинка",
  repeat_password: "Потврди ја новата лозинка",
  old_password: "Стара лозинка",
  code: "Код",
  // LoginController
  invalid_credentials: "Неважечки акредитиви",
  you_dont_have_company_manager_account:
    "Немате сметка на компанија или менаџер",
  // logoutController
  gate_does_not_exist: "Оваа порта не постои во нашата база на податоци!",
  user_is_logged_out: "Корисникот е одјавен", // User is logout
  unauthorized: "Неовластено",
  // Shift Reports
  period_from: "Период од:",
  period_to: "Период до:",
  select_date: "Одберете датум",
  department: "Оддел:",
  generate: "Приказ",
  export: "Експортирај",
  team: "Tим:",
  user: "Корисник:",
  all_without_deactivated: "Сите, освен деактивирани",
  all: "Сите",
  person_report: "Лице",
  day_day: "Ден",
  shiftName: "Смена",
  dateDate: "Датум",
  shiftStartTime: "Закажано почетно време",
  shiftEndTime: "Закажано крајно време",
  shiftTotalTime: "Вкупно закажано",
  total_reports: "Тотал",
  shifts_report: "AbSent Извештај за смени", 
  invalid_input_data: "Се појави грешка",
  // Calendar Reports
  calendar_reports: "Календарски извештаи",
  cumulative_report: "Збирен извештај",
  absent_cumulative_report: "AbSent Збирен извештај",
  periodic_report: "Извештај по периоди",
  absent_periodic_report: "AbSent Извештај по периоди",
  toggle_columns: "Вклучете ги колоните:",
  annual_leave_unused: "Годишен одмор - Неискористен",
  annual_leave_pending: "Годишен одмор - На одбрување",
  annual_leave_used: "Годишен одмор - Искористен",
  vacation_name: "Назив на годишен одмор",
  personal_days: "Платено отсуство",
  paid_parental_leave: "Платено породилно отсуство",
  unpaid_parental_leave: "Неплатено породилно отсуство",
  // Presence Reports
  presence_reports: "Извештаи за присуства",
  cumulative: "Збирен",
  daily: "Дневен",
  detailed: "Детален",
  choose_user: "Изберете корисник",
  expected_regular_time: "Очекувано редовно време",
  expected_and_total_time_difference: "Разлика меѓу очекувано и вкупно време",
  overtime_work: "Прекувремена работа",
  total_scheduled: "Вкупно закажано",
  expected_and_total_time_difference_with_overtime: "Разлика меѓу очекувано, вкупно време и прекувремена работа",
  total_logged_hours: "Вкупно регистрирано време",
  unauthorized_absence: "Неовластено отсуство",
  scheduled_start_time: "Закажано почетно време",
  logged_start_time: "Регистрирано време на почеток",
  scheduled_end_time: "Закажано крајно време",
  logged_end_time: "Регистрирано крајно време",
  note: "Забелешка",
  day_and_date: "Ден / Датум",
  time: "Време",
  registered_on: "Заведено на",
  show_image: "Прикажи слика",
  role: "Улога:",
  direct_superior: "Директен претпоставен:",
  report_generated_on: "Извештај генериран на:",
  small_at: "во",
  selected_period: "Одбран период:",
  presence_details: "Детали за присуство",
  presence_type: "Тип на присуство",
  start_time: "Почетно Време",
  end_time: "Крајно Време",
  registered_start_time: "Заведено на",
  registered_end_time: "Заведено до",
  presence_image: "Слика за присуство",
  image_save_at: "Сликата е сочувана во",
  small_on: "на",
  presence_image: "Слика за присуство",
  presence_report_excel: "AbSent Детален извештај",
  presence_report_pdf: "AbSent Извештаи за присуства",
  // Administrative Report
  administrators_report: "Администраторски извештај",
  attendance_images_reviewed: "Прегледани слики за присуство",
  reviewed_by: "Прегледана од:",
  date_and_time_of_review: "Датум и време на преглед:",
  image_of: "Слика од:",
  image_saved_on: "Сликата е сочувана на:",
  saved_from_device: "Сочувана од уред:",
  show_images: "Приказ на слики:",
  absent_attendance_images_reviewed: "AbSent Прегледани слики за присуство",
  // Nationality And Religion
  settings: "Подесувања",
  add_nationality: "Додади Националност",
  add_religion: "Додади Религија",
  nationality_religion: "Националност/Религија",
  nationality: "Националност",
  religion: "Религија",
  nationality_required: "Националност е задолжително",
  edit_nationality: "Промени Националност",
  delete_this_nationality: "Дали сте сигурни дека сакате да ја избришете оваа националност?",
  uneditable: "Непроменливо",
  delete_nationality: "Избриши Националност",
  nationality_successfully_deleted: "Националноста беше успешно избришана",
  nationality_successfully_updated: "Националноста е успешно ажурирана",
  other: "Останати",
  nationality_successfully_created: "Националноста е успешно креирана",
  create_nationality: "Креирај Националност",
  create_religion: "Креирај Религија",
  edit_religion: "Промени Религија",
  delete_religion: "Избриши Религија",
  religion_successfully_updated: "Религијата успешно се ажурираше",
  delete_this_religion: "Дали сте сигурни дека сакате да ја избришете оваа религија?",
  religion_successfully_deleted: "Религијата беше успешно избришана",
  religion_successfully_created: "Религијата е успешно креирана",
  religion_required: "Религија е задолжително",
  // Users
  users: "Корисници",
  active_users: "Активни корисници",
  deactivated_users: "Деактивирани корисници",
  blocked_users: "Блокирани корисници",
  email: "Емаил",
  phone: "Телефон",
  qr_code: "QR Код",
  work_rules: "Правила за работа",
  deactivated_at: "Деактивиран на",
  activate: "Активирај",
  are_you_sure_want_to_activate_this_user: "Дали сте сигурни дека сакате да го активирате овој корисник?",
  yes_activate_it: "Да, активирај го!",
  user_was_successfully_activated: "Корисникот беше успешно активиран",
  user_was_successfully_unblocked: "Корисникот беше успешно одблокиран",
  are_you_sure_want_to_unblock_this_user: "Дали сте сигурни дека сакате да го одблокирате овој корисник?",
  yes_unblock_it: "Да, одблокирај го!",
  unblock: "Одблокирај",
  user_was_successfully_blocked: "Корисникот беше успешно блокиран",
  are_you_sure_want_to_block_this_user: "Дали сте сигурни дека сакате да го блокирате овој корисник?",
  yes_block_it: "Да, блокирај го!",
  info_title: "Инфо",
  add_user: "Додади корисник",
  download_all_qr_code: "Преземи ги сите QR Кодови",
  block: "Блокирај",
  edit_details: "Промени детали",
  email_address_required: "Емаил адреса е задолжително",
  employee_start_date: "Датум на вработување",
  account_type: "Тип на профилот",
  belongs_to_the_department: "Припаѓа на одделот",
  enter_account_details: "Внесете податоци за сметката",
  belongs_to_the_team: "Припаѓа на тимот",
  employee_start_date_required: "Датум на вработување е задолжително",
  account_type_required: "Тип на профилот е задолжително",
  belongs_to_department_required: "Припаѓа на одделот е задолжително",
  team_required: "Припаѓа на тим е задолжително",
  user_successfully_created: "Корисникот беше успешно креиран",
  date_invalid: "Невалиден датум",
  employee_end_date: "Датум на завршување на работата",
  edit_user: "Промени корисник",
  edit_account_details: "Промена на податоци за сметката",
  edit_personal_details: "Промена на лични податоци",
  user_successfully_updated: "Корисникот успешно се ажурираше",
  please_fill_required_fields: "Ве молиме пополнете ги задолжителните полиња",
  review_and_change_rest_days: "Преглед и промена на бројот на денови за одмор за:",
  rest_days_sucessfully_created: "Неделниот одмор е успешно креиран",
  vacation_and_rest_days: "Годишен одмор / Денови за одмор",
  "days": {
    "monday": "Понеделник",
    "tuesday": "Вторник",
    "wednesday": "Среда",
    "thursday": "Четврток",
    "friday": "Петок",
    "saturday": "Сабота",
    "sunday": "Недела"
  },
  review_and_change_number_of_days: "Преглед и промена на бројот на денови за годишен одмор за:",
  date_of_acquisition: "Датум на стекнување",
  number_of_days_for_annual_leave_unused: "Број на денови за годишен одмор - Неискористени",
  number_of_days_for_annual_leave_pending: "Број на денови за годишен одмор - На одобрување",
  number_of_days_for_annual_leave_used: "Број на денови за годишен одмор - Искористени",
  actions: "Дејства",
  add_row: "Додади",
  vacation_successfully_saved: "Правилото за годишни одмори е успешно додадено",
  vacation_successfully_deleted: "Правилото за годишни одмори е успешно избришано",
  work_hours: "Работни часови",
  review_and_change_working_hours: "Преглед и промена на работни часови за:",
  max_time_paid_break: "Максимално време за платена пауза",
  flexible_work_schedule: "Вкупно редовни часови за флексибилно работно време (работа+теренска работа+платена пауза)",
  flexible_working_hours: "Доколку има дефинирано смена на даден ден, работните часови за флексибилно работно време не се земаат во предвид.",
  paid_hours_for_holiday_and_leave: 'Бројот на редовно платени часови за празник и отсуство се пресметуваат според бројот на "Вкупно редовни часови за флексибилно работно време".',
  automatic_presence_stop: "Овозможи автоматско исклучување на присуство",
  enable_saving_images: "Овозможи зачувување на слики",
  disable_overtime_for_user: "Оневозможи прекувремена работа за работникот",
  disable_presence_logging: "Оневозможи евиденција на присуство:",
  using_the_web: "Преку веб",
  using_mobile_app: "Преку мобилната апикација",
  max_time_for_auto_presence_stop_flexible_schedule: "Максимално време за автоматско исклучување за флексибилно работно време ",
  work_field_work_paid_break: "(работа+теренска работа+платена пауза)",
  employee_no_scheduled_shift_auto_presence_stop_executed: "Во случај кога за вработениот нема закажано смена, автоматското исклучување се извршува за според параметрите погоре и тоа на континуиран сегмент за присуство (работа, пауза или теренска работа).",
  employee_has_scheduled_shift_max_time_not_taken_into_account: "Во случај кога вработениот има закажано фиксна или лизгачка смена, параметарот за максимално време, дефиниран погоре, не се зема во предвид туку автоматското исклучување се извршува после изминување на крајното време на смената и опсегот за заокружување на фиксно крајно време.",
  user_has_existing_schedules_message: "Дали сте сигурни дека сакате да ги зачувате работните часови за овој корисник?",
  yes_save_it: "Да, зачувај!",
  data_saved_successfully: "Работните часови за корисникот беа успешно зачувани",
  all_qr_codes: "Сите QR Кодови",
  // Departments
  departments: "Оддели",
  add_departments: "Додади Оддел",
  department_manager: "Менаџер на оддел",
  default: "Основен",
  delete_this_department: "Дали сте сигурни дека сакате да го избришете овој оддел?",
  department_successfully_deleted: "Одделот беше успешно избришан",
  edit_department: "Уреди оддел",
  delete_department: "Избриши оддел",
  create_department: "Креирај оддел",
  department_name: "Име на оддел:",
  department_manager: "Менаџер на одделот:",
  department_members: "Членови на одделот:",
  department_name_required: "Име на оддел е задолжително",
  department_lead_required: "Менаџер на одделот треба да биде селектиран",
  department_successfully_created: "Успешно креиран оддел",
  department_unchanged: "Одделот не беше променет",
  department_successfully_updated: "Успешно променет оддел",
  select_team: "Одберете тим",
  select_department: "Одберете оддел",
  select_date_form: "Одберете датум",
  enter_personal_details: "Внесете лични податоци",
  full_name_to_display: "Име и презиме за приказ",
  full_name_required: "Име и презиме во документи е задолжително",
  job_position_in_docs_required: "Работна позиција во документи е задолжително",
  display_job_position_required: "Работна позиција за приказ е задолжително",
  full_name_to_display_required: "Име е задолжително",
  select_religion: "Одберете религија",
  select_country: "Одберете држава",
  select_nationality: "Одберете националност",
  display_job_position_users: "Работна позиција за приказ",
  differentiation_color: "Боја за препознавање",
  select_type: "Одберете тип",
  administration: "Човечки ресурси",
  teamlead: "Тим лидер",
  teammember: "Член на тим",
  deplead: "Менаџер на оддел",
  sysadmin: "Систем aдминистратор",
  // Holidays
  for_all_citizens: "За сите граѓани",
  year: "Година:",
  type_type: "Тип",
  add_holiday: "Додади празници",
  delete_this_holiday: "Дали сте сигурни дека сакате да го избришете овој празник?",
  holiday_successfully_deleted: "Празникот беше успешно избришан",
  delete_holiday: "Избриши празник",
  create_holiday: "Креирај празник",
  holiday_type: "Вид на празник",
  official_holiday: "Државен празник",
  ethnic_holiday: "Етнички",
  religious_holiday: "Религиозен",
  users_that_have_rest_days: "На избраниот датум има корисници кои имаат неделен одмор. Дали сте сигурни дека сакате да го избришете неделниот одмор од овој датум, за сите корисници?",
  holiday_successfully_created: "Празникот беше успешно создаден",
  date_required: "Датум е задолжително",
  description_required: "Опис е задолжително",
  holiday_type_required: "Вид на празник е задолжително",
  national_type_required: "Национален е задолжително",
  religious_type_required: "Религиозен е задолжително",
  national_type: "Национален",
  religious_type: "Религиозен",
  select_option: "Изберете опција",
  holidays: "Празници",
  // Register page
  register_company: "Регистрирај фирма",
  email_register: "Е-пошта",
  password: "Лозинка",
  confirm_password: "Потврди ја лозинката",
  account_type_register: "Тип на профилот",
  by_registering_in_absent: "Со регистрација во Absent, вие се согласувате со овие:",
  terms_and_conditions_register: "правила и услови.",
  register_button: "Регистрирај се",
  or_register: "или",
  login_to_your_account: "Најави се",
  email_verification: "Потврда на е-пошта",
  email_verified: "Е-поштата е успешно потврдена!",
  your_email_successfully_verified: "Вашата е-пошта е успешно потврдена. Сега можете да се најавите.",
  email_verification_failed: "Потврдата на е-поштата не е успешна!",
  resend_verification_email: "Повторно испрати е-пошта за потврда",
  email_field_required: "Е-пошта",
  email_field_required: "Полето е-пошта е задолжително",
  confirm_password_required: "Полето потврди ја лозинката е задолжително",
  role_required: "Полето тип на профилот е задолжително",
  agree_terms: "Полето правила и услови е задолжително",
  password_mismatch: "Лозинките не се совпаѓаат",
  verifying_your_email: "Проверка на вашата е-пошта...",
  "recaptcha_verification_failed": "reCAPTCHA верификацијата е неуспешна",
  "failed_to_create_user": "Неуспешно креирање корисник",
  "register_unexpected_error": "Настана неочекувана грешка при регистрација",  
  "registration_success": "Успешна регистрација! Ве молиме проверете ја вашата е-пошта за да ја верификувате сметката", 
  "register_validation_failed": "Грешка при валидација на регистрација",
  "invalid_link": "Невалиден линк",
  "invalid_expired_link": "Линкот за верификација е невалиден или истечен",
  "already_verified": "Веќе верификувано",
  "verification_success": "Верификацијата е успешна",
  "verification_failed": "Верификацијата е неуспешна",
  "verification_unexpected_error": "Неочекувана грешка при верификација", 
  "user_not_found": "Корисникот не е пронајден",
  "already_verified": "Веќе верификувано",  
  "verification_resent": "Верификацијата е повторно испратена, ве молиме проверете ја вашата е-пошта",
  "resend_validation_failed": "Повторното испраќање на верификацијата е неуспешно",
  "resend_unexpected_error": "Настана неочекувана грешка при повторно испраќање",
  // ProfileApiController
  changing_starting_date:
    "За промена на датумот на започнување на вработениот, ве молиме, сите нејзини / негови отсуства да бидат одбиени!!",
  error: "Грешка",
  profile_was_successfully_updated: "Профилот беше успешно ажуриран",
  password_changed_successfully: "Успешна промена на лозинката",
  avatar_changed_successfully: "Успешна промена на сликата",
  // PresenceApiController
  working_hours_allowed: "Број на работни часови е поголем од дозволеното!!",
  not_found: "Не е најдено",
  // AbsenceApiController
  permission_to_schedule_rest_days:
    "Немате дозвола да подесувате денови за неделен одмор, за себе",
  submit_absence_request:
    "За да поднесете барање за отсуство, избраните датуми треба да бидат сегашни или идни датуми!",
  to_do_this_change:
    "За да можете да ја направите оваа промена, Ве молиме најпрвин избришете ги сите идни отсуства на овој корисник",
  you_can_not_create_more_than_two_rest_days:
    "Не можете да креирате повеќе од два дена за неделен одмор",
  rest_day_successfully_created: "Отсуството беше успешно креирано",
  select_one_day_to_switch:
    "Можете да изберете само еден ден за да се префрлите!!!",
  human_resources_role_can_not_create_absence:
    "Администрацијата не може да создаде отсуство за други корисници подоцна од:",
  submit_a_request_for_vacation:
    "За да поднесете барање за годишен одмор, избраниот датум треба да биде најмалку 3 работни дена од денешниот ден",
  absence_was_successfully_created: "Отсуството беше успешно креирано",
  select_at_least_one_day:
    "Мора да изберете барем еден ден за да поднесете барање за Отсуство!",
  comment_successfully_changed: "Коментарот е успешно променет",
  documents_uploaded_successfully: "Датотеката е успешно закачена",
  // ManagementApiController
  rest_day_was_successfully_rejected: "Денот за неделен одмор е успешно одбиен",
  // ApiUserController
  company_does_not_exist:
    "Оваа компанија не постои во нашата база на податоци!",
  wrong_qr_code: "Погрешен QR код!",
  user_does_not_exist: "Овој корисник не постои во нашата база на податоци!",
  device_id_is_required: "Потребен е ID на уредот!",
  device_id_does_not_exist:
    "Овој ID на уред не постои во нашата база на податоци!",
  // ApiPresenceController
  management_disabled_your_logging:
    "Менаџментот на вашата компанија го оневозможи Вашето регистрирање!",
  gate_does_not_exist: "Оваа порта не постои во нашата база на податоци!",
  gate_is_not_active: "Оваа порта не е активна!",
  // REQUESTS
  file_field_is_required: "Полето за датотека е задолжително.",
  file_must_be_an_image: "Датотеката мора да биде слика.",
  jpeg_jpg_png_files_allowed: "Дозволени се само датотеки JPEG, JPG и PNG.",
  file_size_1MB: "Големината на датотеката не може да надмине 1MB.",
  jpg_jpeg_png_images_allowed:
    "Само JPG, JPEG и PNG \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 слики се дозволени за поставување",
  personal_days_type_field_required:
    "Полето Тип на персонални денови е задолжително.",
  switch_days_field_required: "Полето Заменет ден е задолжително.",
  comment_filed_required: "Полето Коментар е задолжително.",
  invalid_document_format: "Неважечки формат на документ.",
  upload_up_to_5_files: "Максимално дозволени датотеки е 5!",
  invalid_file_format: "Неважечки формат на датотека.",
  jpeg_pdf_file_formats_allowed:
    "Дозволени се само формати на датотеки JPEG и PDF.",
  max_characters_allowed: "Дозволени се најмногу 250 знаци",
  required_field: "Недостасува или e празно задолжително поле.",
  invalid_input: "Invalid input",
  comment_required: "Коментарот е задолжителен.",
  comment_250_characters: "Коментарот не смее да надмине 250 знаци.",
  no_file_selected: "Нема избрана датотека.",
  jpg_jpeg_pdf_files_allowed: "Дозволени се само датотеки JPG, JPEG и PDF.",
  uploaded_file_size_exceeds_allowed_limit:
    "Големината на поставената датотека ја надминува дозволената граница.",
  first_name_required: "Име е задолжително",
  first_name_must_be_at_least: "Името мора да е најмалку :min знаци",
  first_name_max_characters: "Името може да е максимум :max знаци",
  valid_email_address: "Ве молиме внесете валидна е-пошта",
  email_must_be_at_least: "Емаил адресата може да е максимум :max знаци",
  birthday_required: "Роденден е задолжително",
  country_required: "Држава е задолжително",
  employment_start_date_required:
    "Датум на започнување со вработување е задолжително",
  full_name_in_docs_required: "Име и презиме во документи е задолжително",
  full_name_in_docs_must_be_at_least:
    "Име и презиме во документи мора да е најмалку :min знаци",
  full_name_in_docs_max_characters:
    "Име и презиме во документи може да е максимум :max знаци",
  employee_position_in_docs_required:
    "Работна позиција во документи е задолжително",
  employee_position_in_docs_must_be_at_least:
    "Работна позиција во документи мора да е најмалку :min знаци",
  employee_position_in_docs_max_characters:
    "Работна позиција во документи може да е максимум :max знаци",
  employee_position_required: "Работна позиција е задолжително",
  employee_position_must_be_at_least:
    "Работна позиција мора да е најмалку :min знаци",
  employee_position_max_characters:
    "Работна позиција може да е максимум :max знаци",
  email_required: "Емаил е задолжително",
  email_invalid: "Невалиден емаил",
  email_has_already_been_taken: "Адресата на е-поштата веќе се користи",
  password_required: "Полето лозинка е задолжително",
  password_confiramtion: "Лозинките не се совпаѓаат",
  password_confiramtion_required: "Полето потврда за лозинка е задолжително",
  password_characters: "Лозинката треба да има најмалку 8 знаци",
  passwrod_max_length: "Максималната должина на лозинката е 30 карактери",
  terms_and_conditions_required: "Услови и правила се задолжителни",
  user_role_required: "Тип на профилот е задолжително.",
  old_password_required: "Полето стара лозинка е задолжително",
  user_language_changed_successfully: "Корисничкиот јазик е успешно променет",
  // yup password validations
  new_password_required: "Полето нова лозинка е задолжително",
  repeat_password_required: "Полето за повторување на лозинката е задолжително",
  old_and_new_password_must_be_different:
    "Старата и новата лозинка мора да бидат различни",
  new_and_repeat_password_must_match:
    "Новата и повторената лозинка мора да се исти",
  password_must_be_at_least: "Лозинката мора да има најмалку 8 знаци",
  password_must_contain:
    "Лозинката мора да содржи најмалку една голема буква, една мала буква, еден број и еден симбол",
  field_required: "Ова поле е задолжително",
  // Cookie and Privacy Policy
  cookie_alert_text: `Користиме колачиња да го подобриме вашето искуство на нашата апликација. За да дознаете повеќе, прочитајте ја нашата`,
  cookie_policy: "Политика за користење колачиња",
  cookie_policy_title: "Политика за користење колачиња",
  cookie_policy_user: `
    <p>
		Колачињата се користат со цел да се овозможи услугата која што се обезбедува преку страната, како и колачиња кои имаат за цел да се подобри услугата и/или подобро да се усогласи со Вашите потреби.
	</p> 
		<h5>Видови на колачиња кои ги користиме; </h5>

    <p>
    Колачињата кои ги користиме се строго-задолжителни колачиња кои ја следат услугата и без чие користење истата не би можела да функционира и затоа неможат да се исклучат.
    </p>
    <h5>Согласност од Корисникот на AbSent</h5>

	<p>Со секоја посета на страната од страна на Корисникот, вклучени се само строго-задолжителните колачиња, без кои услугата не е возможно да се обезбеди.</p>

	<p>Подолу следува описот на колачињата кои се користат при користење на AbSent, нивната функција:</p>

      <table class="table table-striped">
		  <thead>
		    <tr>
		      <th scope="col">Р.бр.</th>
		      <th scope="col">Назив на колаче/фајл/датотека</th>
		      <th scope="col">Функција</th>
		    </tr>
		  </thead>
		  <tbody>
		    <tr>
			    <th scope="row">1</th>
			    <td>XSRF-TOKEN</td>
			    <td>
			    	Заштита на системот во форма на случајна низа која го заштитува местото на хакерски напади, без да ги земате вашите лични информации на било кој начин.
			    </td>
		    </tr>
		    <tr>
			    <th scope="row">2</th>
			    <td>absent_session</td>
			    <td>
					Чува податоците за системот, без да ги зема личните информации на било кој начин.
			    </td>
		    </tr>
		    <tr>
			    <th scope="row">3</th>
			    <td>_ga, _gid</td>
			    <td>
					Овие колачиња се користат за собирање информации за тоа како посетителите го користат нашиот сајт. Ние ги користиме информациите за да составиме извештаи и да ни помогнеме да ја подобриме страницата. Колачињата собираат информации во анонимна форма, вклучувајќи го и бројот на посетители на страницата, каде што посетителите доаѓаат од географски, и страниците што ги посетија, уредите и прелистувачите што посетителите ги користат.
			    </td>
		    </tr>
		    <tr>
				<th scrop="row">3</th>
				<td>absent-cookie-policy-consent</td>
				<td>
					Ова колаче се користи за снимање ако некој посетител ја видел лентата со известување за нашата политика за користење колачиња. 
				</td>
		    </tr>
		  </tbody>
		</table>

      	<p>
            Последен пат ажурирано на ден: 01 01 2020. година.
        </p>

    `, //end of user cookie policy description

  i_agree: "Се сложувам",

  privacy_policy_title: "Политика за приватност",
  privacy_policy_user: `
        <p>
            Со оваа политика за приватност појаснуваме како ние, Друштво за инженеринг СЕНТИЦЕ ТЕЦХ ДООЕЛ Скопје, 
            постапувајќи како Обработувач (во понатамошниот текст: Сентице), ги собираме и користиме податоците за тебе и твоето користење на 
            Мобилната и веб апликација AbSent (во понатамошниот текст: Лични податоци), со цел да ја обезбедиме нашата услуга до Вас, 
            како вработени лица кај Работодавачот.
        </p>

        <p>
            Попрецизно, оваа политика за приватност дава објаснување како ние ги собираме, користиме, 
            обработуваме и случаи во кои може да ги откриеме личните податоци, a во врска со Вашето користење на услугата., 
            преку AbSent - апликацијата за евиденција на отсуства, заради исполнување на законски,  
            договорни обврски и заеднички легитимни интереси (евиденција на отсуства од работа);
        </p>

        <p>
            Дел од вашите податоци ние ги добиваме од Вашиот Работодавач, кој ги внесува во AbSent, 
            заради креирање на Ваша лична корисничка сметка, со која Вие ќе можете 
            самостојно да продолжите со користењето на услугата на начин што ќе можете да внесувате отсуства од работа.
        </p>

      <h5>Лични податоци кои ги собираме и како ги користиме</h5>
        <p>
            Податоците кои ги собираме, ние ги добиваме преку Вашиот Работодавач, 
            кој ни ги доставува заради креирање на Ваша лична корисничка сметка, 
            на начин што Работодавачот или лице овластено од него самостојно ги внесува во Апликацијата: AbSent
        </p>

        <p>
            Податоците кои ги добиваме се следни:
        </p>

        <ul class="dashed">
            <li>
                име и презиме,
            </li>
            <li>
                телефонски број,
            </li>
            <li>
                ден и месец на раѓање,
            </li>
            <li>
                националност и религиозна припадност.
            </li>
        </ul>

        <p>
            Цел: Ние ги користиме Вашите лични податоци исклучиво за да ги исполниме договорните обврски со Вашиот Работодавач, 
            како и да Ви ја овозможиме услугата за евиденција на Вашите лични отсуства преку AbSent.
        </p>
        <p>
            Ние ги собираме личните податоци, кои Вашиот Работодавач и Вие ги споделувате доброволно.
        </p>

      <h5>Автоматско собирање на податоци</h5>
        <p>
            Собираме податоци и автоматски, преку cookies. Овие податоци ги користиме за да ја обезбедиме и подобриме услугата.
        </p>
        <p>
            Податоците не вклучуваат Ваша содржина или податоци генерирани од вас.
        </p>
        <p>
            За повеќе информации околу начинот на кој се собираат и обработуваат податоците преку автоматско собирање со користење колачиња (cookies), 
            прочитајте ја <a href="/cookie-policy" target="_blank">Политиката за користење колачиња</a>.
        </p>
        <p>
            Покрај горенаведените податоци по потреба може да ја користиме и 
            IP aдресата од која пристапувате до услугата, како и други податоци за откривање на Вашиот идентитет, 
            само и единствено во случај кога тоа е неопходно и задолжително во согласност со законските прописи.
        </p>
      <h5>Складирање и пренос на податоците</h5>
      <h6>За подобра и целосна заштита, Друштвото користи клауд систем на правење сигурносни копии (cloud based back-up system) на сервери кои се лоцирани во во рамки на Европската Унија, поконкретно во Франкфурт Германија.</h6>
      <h6>Во поглед на обработката на Вашите податоци, Вие ги имате следните права:</h6>
      <p>
        <ul class="dashed">
            <li>пристап и промена на моите лични податоци;</li>
            <li>
                право за блокирање на обработката на моите лични податоци поради посебна причина/ситуација;
            </li>
            <li>
                приговор, како и право на пренос на моите лични податоци на некој друг контролор, во соодветна форма;
            </li>
        </ul>
      </p>

      <h5>Право на пристап на личните податоци</h5>
        <p>
            Право на пристап: Со оваа политика Ви укажуваме дека ние не внесуваме, ажурираме и/или бришеме лични податоци кои се внесени 
            од Вашиот Работодавач и лично од Вас. Доколку побарате, право на пристап, ажурирање или бришење на податоците, 
            тоа можете да го сторите преку Вашиот работододавач, кој ги внел податоците односно кој има авторизации да внесува, 
            ажурира или брише податоци, кои ги внесува наместо Вас.
        </p>

        <p>
            Ние единствено ги складираме податоците кои се внесени од Вас или од Вашиот Работодавач на сервер, 
            заради исполнување на договорни обврски и за да ви овозможиме користење на услугата. Овие податоци се складираат енкриптирани и не се во читлива форма.
        </p>

      <h5>Безбедност на податоците</h5>
        <p>
            Ние обезбедуваме разумни мерки  за да овозможиме соодветно физичка, техничка и електронска безбедност на податоците.,
        </p>
        <p>
            Ние имплементираме безбедносни мерки за физичка и техничка заштита на податоците од губење, уништување и неовластен пристап, 
            објавување или неовластено навлегување.
        </p>
        <p>
            И покрај овие мерки, не постои безбедносна мерка што гарантира комплетна (100%) сигурност во текот на целиот период.
        </p>

      <h5>Начин на известување во случај на промени во политиката</h5>

        <p>
            Измени во политиката за приватност. Оваа политика за приватност може да претрпи одредени измени од време на време, 
            во согласност со применливите прописи за заштита на личните податоци. Ние ќе ве известиме 
            за секоја промена која се однесува на начинот на кој се постапува со личните податоци кој се 
            собрани претходно и водно ќе ви дадеме можност да одберете дали сакате да се користат и понатаму.
        </p>

      <p>
          Последен пат ажурирано на: 1. 1. 2020
      </p>
    `, //end of user privacy policy description
  privacy_policy_user_modal: `
        <p>
            Со оваа политика за приватност појаснуваме како ние, Друштво за инженеринг СЕНТИЦЕ ТЕЦХ ДООЕЛ Скопје, 
            постапувајќи како Обработувач (во понатамошниот текст: Сентице), ги собираме и користиме податоците за тебе и твоето користење на 
            Мобилната и веб апликација AbSent (во понатамошниот текст: Лични податоци), со цел да ја обезбедиме нашата услуга до Вас, 
            како вработени лица кај Работодавачот.
        </p>

        <p>
            Попрецизно, оваа политика за приватност дава објаснување како ние ги собираме, користиме, 
            обработуваме и случаи во кои може да ги откриеме личните податоци, a во врска со Вашето користење на услугата., 
            преку AbSent - апликацијата за евиденција на отсуства, заради исполнување на законски,  
            договорни обврски и заеднички легитимни интереси (евиденција на отсуства од работа);
        </p>

        <p>
            Дел од вашите податоци ние ги добиваме од Вашиот Работодавач, кој ги внесува во AbSent, 
            заради креирање на Ваша лична корисничка сметка, со која Вие ќе можете 
            самостојно да продолжите со користењето на услугата на начин што ќе можете да внесувате отсуства од работа.
        </p>

      <h5>Лични податоци кои ги собираме и како ги користиме</h5>
        <p>
            Податоците кои ги собираме, ние ги добиваме преку Вашиот Работодавач, 
            кој ни ги доставува заради креирање на Ваша лична корисничка сметка, 
            на начин што Работодавачот или лице овластено од него самостојно ги внесува во Апликацијата: AbSent
        </p>

        <p>
            Податоците кои ги добиваме се следни:
        </p>

        <ul class="dashed">
            <li>
                име и презиме,
            </li>
            <li>
                телефонски број,
            </li>
            <li>
                ден и месец на раѓање,
            </li>
            <li>
                националност и религиозна припадност.
            </li>
        </ul>

        <p>
            Цел: Ние ги користиме Вашите лични податоци исклучиво за да ги исполниме договорните обврски со Вашиот Работодавач, 
            како и да Ви ја овозможиме услугата за евиденција на Вашите лични отсуства преку AbSent.
        </p>
        <p>
            Ние ги собираме личните податоци, кои Вашиот Работодавач и Вие ги споделувате доброволно.
        </p>

      <h5>Автоматско собирање на податоци</h5>
        <p>
            Собираме податоци и автоматски, преку cookies. Овие податоци ги користиме за да ја обезбедиме и подобриме услугата.
        </p>
        <p>
            Податоците не вклучуваат Ваша содржина или податоци генерирани од вас.
        </p>
        <p>
            Покрај горенаведените податоци по потреба може да ја користиме и 
            IP aдресата од која пристапувате до услугата, како и други податоци за откривање на Вашиот идентитет, 
            само и единствено во случај кога тоа е неопходно и задолжително во согласност со законските прописи.
        </p>
      <h5>Складирање и пренос на податоците</h5>
      <h6>За подобра и целосна заштита, Друштвото користи клауд систем на правење сигурносни копии (cloud based back-up system) на сервери кои се лоцирани во во рамки на Европската Унија, поконкретно во Франкфурт Германија.</h6>
      <h6>Во поглед на обработката на Вашите податоци, Вие ги имате следните права:</h6>
      <p>
        <ul class="dashed">
            <li>пристап и промена на моите лични податоци;</li>
            <li>
                право за блокирање на обработката на моите лични податоци поради посебна причина/ситуација;
            </li>
            <li>
                приговор, како и право на пренос на моите лични податоци на некој друг контролор, во соодветна форма;
            </li>
        </ul>
      </p>

      <h5>Право на пристап на личните податоци</h5>
        <p>
            Право на пристап: Со оваа политика Ви укажуваме дека ние не внесуваме, ажурираме и/или бришеме лични податоци кои се внесени 
            од Вашиот Работодавач и лично од Вас. Доколку побарате, право на пристап, ажурирање или бришење на податоците, 
            тоа можете да го сторите преку Вашиот работододавач, кој ги внел податоците односно кој има авторизации да внесува, 
            ажурира или брише податоци, кои ги внесува наместо Вас.
        </p>

        <p>
            Ние единствено ги складираме податоците кои се внесени од Вас или од Вашиот Работодавач на сервер, 
            заради исполнување на договорни обврски и за да ви овозможиме користење на услугата. Овие податоци се складираат енкриптирани и не се во читлива форма.
        </p>

      <h5>Безбедност на податоците</h5>
        <p>
            Ние обезбедуваме разумни мерки  за да овозможиме соодветно физичка, техничка и електронска безбедност на податоците.,
        </p>
        <p>
            Ние имплементираме безбедносни мерки за физичка и техничка заштита на податоците од губење, уништување и неовластен пристап, 
            објавување или неовластено навлегување.
        </p>
        <p>
            И покрај овие мерки, не постои безбедносна мерка што гарантира комплетна (100%) сигурност во текот на целиот период.
        </p>

      <h5>Начин на известување во случај на промени во политиката</h5>

        <p>
            Измени во политиката за приватност. Оваа политика за приватност може да претрпи одредени измени од време на време, 
            во согласност со применливите прописи за заштита на личните податоци. Ние ќе ве известиме 
            за секоја промена која се однесува на начинот на кој се постапува со личните податоци кој се 
            собрани претходно и водно ќе ви дадеме можност да одберете дали сакате да се користат и понатаму.
        </p>

      <p>
          Последен пат ажурирано на: 1. 1. 2020
      </p>
    `,
  OK: "ОК",

  no_right_to_use_vacation: 'Немате право да барате денови за одмор во избраниот период. Ве молиме контактирајте со раководството на вашата компанија или човечки ресурси за поддршка.',
  cannot_take_vacation_in_selected_period: 'Не можете да земете одмор во избраниот период',
  days_exceed_annual_limit: 'Бројот на барани денови е поголем од бројот на денови на годишен одмор за овој период',
  overlapping_personal_days: 'Последниот период на лични денови се преклопува со други одмори.',
  overlapping_absence: 'Корисникот е веќе отсутен во овој период.',
  overlapping_period_or_switch_day: 'Корисникот веќе има отсуство со овој трансфер период/ден.',
  wrong_old_password: 'Погрешна стара лозинка.',

  re_type_new_password: "Повторно напишете нова лозинка",
  save: "Зачувај",
  successfully_logged_in:
    "Успешно сте најавени, ве молиме сменете ја лозинката",
  error_try_again_later: "Нешто тргна наопаку. Обидете се повторно подоцна.",
  error_creating_absence: "Грешка при создавањето отсуство",
  absence_declined: "Отсуството e одбиено.",
  absence_approved:"Отсуството беше успешно одобрено",
  expired_password:"Вашата лозинка е истечена, ве молиме сменете ја.",
  current_password:"Сегашна лозинка",
  confirm_new_password:"Потврди Нова лозинка",
  reset_password:"Ресетирање на Лозинка",

  login: "Најава",
  page_not_found: "Страницата не е пронајдена.",
  go_back_to_home_page: "Врати се на почетната страница",

  last_reason_for_update: "Последна причина за ажурирање",
  reason_for_update: "Причина за ажурирање",
  comment_for_this_presence: "Коментар за ова присуство",
  absent_members: "член/ови се отсутни на овој ден",

  Other: "Останати",

  //months - short translation
  Jan: "Јан",
  Feb: "Фев",
  Mar: "Мар",
  Apr: "Апр",
  May: "Мај",
  Jun: "Јун",
  Jul: "Јул",
  Aug: "Авг",
  Sep: "Сеп",
  Oct: "Окт",
  Nov: "Ное",
  Dec: "Дек",

  "absences": {
    "Annual leave Unused": "Годишен одмор - Неискористен",
    "Annual leave Pending": "Годишен одмор - На одбрување",
    "Annual leave Used": "Годишен одмор - Искористен",
    "Name of vacation": "Назив на годишен одмор",
    "Personal days": "Платено отсуство",
    "Sick leave": "Боледување",
    "Business trip": "Бизнис патување",
    "Work from home": "Работа од дома",
    "Extra days": "Дополнителни денови",
    "Paid parental leave": "Платено породилно отсуство",
    "Unpaid parental leave": "Неплатено породилно отсуство",
    "Unpaid leave": "Неплатено отсуство",
  },

  "presence_report_names": {
    "Person": "Лице",
    "Work": "Работа",
    "Paid Break": "Пауза",
    "Field work": "Теренска работа",
    "Absence": "Отсуство",
    "Holiday": "Празник",
    "Total regular time": "Вкупно редовно време",
    "Expected regular time": "Очекувано редовно време",
    "Expected and total time difference": "Разлика меѓу очекувано и вкупно време",
    "Total scheduled": "Вкупно закажано",
    "Overtime": "Прекувремена работа",
    "Expected and total time difference with overtime": "Разлика меѓу очекувано, вкупно време и прекувремена работа",
    "Presence on night work": "Присуство за време на ноќна работа",
    "Presence on absence": "Присуство за време на отсуство",
    "Presence on holiday": "Присуство за време на празник",
    "Presence on rest day": "Присуство за време на неделен одмор",
    "Total Logged Hours": "Вкупно регистрирано време",
    "Private exit": "Излегување",
    "Unauthorized Absence": "Неовластено отсуство",
    "Exceeded break": "Пречекорена пауза",
    "Unpaid absence": "Неплатено отсуство",
    "Day": "Ден",
    "Date": "Датум",
    "Schedule start time": "Закажано почетно време",
    "Logged start time": "Регистрирано време на почеток",
    "Schedule end time": "Закажано крајно време",
    "Logged end time": "Регистрирано крајно време",
    "Work": "Работа",
    "Paid Break": "Пауза",
    "Field work": "Теренска работа",
    "Absence": "Отсуство",
    "Holiday": "Празник",
    "Total logged time": "Вкупно редовно време",
    "Expected regular time": "Очекувано редовно време",
    "Expected and total time difference": "Разлика меѓу очекувано и вкупно време",
    "Total schedule time": "Вкупно закажано",
    "Overtime": "Прекувремена работа",
    "Expected and total time difference with overtime": "Разлика меѓу очекувано, вкупно време и прекувремена работа",
    "Presence on night work": "Присуство за време на ноќна работа",
    "Presence on absence": "Присуство за време на отсуство",
    "Presence on holiday": "Присуство за време на празник",
    "Presence on rest day": "Присуство за време на неделен одмор",
    "Total Logged Hours": "Вкупно регистрирано време",
    "Private exit": "Излегување",
    "Unauthorized Absence": "Неовластено отсуство",
    "Exceeded break": "Пречекорена пауза",
    "Unpaid absence": "Неплатено отсуство",
    "Note": "Забелешка",
  },
  'Default': 'Основен',
  'Deactivated': 'Деактивиран',
  'Mon': 'Пон',
  'Tue': 'Вто',
  'Wed': 'Сре',
  'Thu': 'Чет',
  'Fri': 'Пет',
  'Sat': 'Саб',
  'Sun': 'Нед',
  'Work': 'Работа',
  'Break': 'Платена пауза',
  'Field work': 'Теренска работа',
  'Private exit': 'Излегување',
  'Work on absence': 'Присуство за време на отсуство',
  'Break on absence': 'Платена пауза за време на отсуство',
  'Field work on absence': 'Теренска работа за време на отсуство',
  'Work on holiday': 'Присуство за време на празник',
  'Break on holiday': 'Платена пауза за време на празник',
  'Field work on holiday': 'Теренска работа за време на празник',
  'Unauthorized Absence': 'Неовластено отсуство',
  'Work on rest day': 'Присуство за време на неделен одмор',
  'Field work on rest day': 'Теренска работа за време на неделен одмор',
  'Break on rest day': 'Платена пауза за време на неделен одмор',
  'Work on night work': 'Присуство за време на ноќна работа',
  'Field work on night work': 'Теренска работа за време на ноќна работа',
  'Break on night work': 'Платена пауза за време на ноќна работа',
"day": {
    "Mon": "Lun",
    "Tue": "Mar",
    "Wed": "Mer",
    "Thu": "Jeu",
    "Fri": "Ven",
    "Sat": "Sam",
    "Sun": "Dim"
  },
  // "teamTranslation": {
  //   "Default": "Основен",
  // },
  // "departmentTranslation": {
  //   "Default": "Основен",
  // }
 "allRoles": {
    "Manager": "Генерален менаџер",
    "Chairman": "Претседател",
    "Human Resources": "Човечки ресурси",
    "Team Lead": "Тим лидер",
    "Team Member": "Член на тим",
    "Department Lead": "Менаџер на оддел",
    "System Administrator": "Систем администратор"
  },
  manager: "Генерален менаџер",
  owner: "Претседател",
  "roles": {
    "General Manager-manager": "Генерален менаџер",
    "System Administrator-sysadmin": "Систем aдминистратор",
    "Chairman-owner": "Претседател",
    "Department Manager-deplead": "Менаџер на оддел",
    "Team Lead-teamlead": "Тим лидер",
    "Team Member-teammember": "Член на тим",
    "Human Resources-administration": "Човечки ресурси",
    "Генерален менаџер-manager": "Генерален менаџер",
    "Претседател-owner": "Претседател",
    "Човечки ресурси-administration": "Човечки ресурси",
    "Менаџер на оддел-deplead": "Менаџер на оддел",
    "Тим лидер-teamlead": "Тим лидер",
    "Член на тим-teammember": "Член на тим",
    "Систем aдминистратор-sysadmin": "Систем aдминистратор",
    "Управител-manager": "Генерален менаџер",
    "Системен администратор-sysadmin": "Систем aдминистратор",
    "Човешки ресурси-administration": "Човечки ресурси",
    "Председател-owner": "Претседател",
    "Ръководител на отдел-deplead": "Менаџер на оддел",
    "Ръководител на екипа-teamlead": "Тим лидер",
    "Член на екипа-teammember": "Член на тим"
  },
  vacation_period_desc: "Период на употреба на одмор",
  document_full_name_desc: "Целосно име на подносителот што е внесено на неговиот локален јазик",
  birthday_desc: "Датум на роденден на подносителот",
  document_job_position_desc: "Работна позиција на подносителот што е внесена на неговиот локален јазик",
  requested_days_desc: "Број на барани денови од подносителот",
  next_day_desc: "Пресметан ден на подносителот за кога треба да се врати на работа",
  display_leave_type_desc: "Вид на отсуство",
  start_day_desc: "Датум на започнување на барањето за отсуство",
  end_day_desc: "Датум на завршување на барањето за отсуство",
  display_full_name_desc: "Целосно име на подносителот",
  display_job_position_desc: "Работна позиција на подносителот",
  email_desc: "Е-пошта на подносителот",
  team_desc: "Тим на подносителот",
  empl_start_day_desc: "Датум на започнување со работа на подносителот",
  phone_desc: "Телефон на подносителот",
  document_leave_type_desc: "Вид на отсуство на подносителот што е внесено на неговиот локален јазик",
  absent_created_desc: "Датум кога е креирано отсуството",
  absent_change_status_desc: "Датум кога е сменет статусот на отсуство",
  submited_tag_desc: "Поднесенo од",
  gm_tag_desc: "Таг за Генерален манаџер",
  hr_tag_desc: "Таг за Човечки ресурси",
  dl_tag_desc: "Таг за Менаџер на оддел",
  tl_tag_desc: "Таг за Тим лидер",
  submited_time_tag_desc: "Време кога е поднесено барањето",
  gm_approved_time_tag_desc: "Време кога барањето е одобрено од генералниот директор",
  hr_approved_time_tag_desc: "Време кога барањето е одобрено од човечки ресурси",
  dl_approved_time_tag_desc: "Време кога барањето е одобрено од раководителот на Одделот",
  tl_approved_time_tag_desc: "Време кога барањето е одобрено од раководителот на Тимот",
  absence_comment_desc: "Коментар од барање за отсуство",
  submited_date_tag_desc: "Датум кога е поднесено барањето",
  gm_approved_date_tag_desc: "Датум кога барањето е одобрено од генералниот директор",
  hr_approved_date_tag_desc: "Датум кога барањето е одобрено од човечки ресурси",
  dl_approved_date_tag_desc: "Датум кога барањето е одобрено од раководителот на Одделот",
  tl_approved_date_tag_desc: "Датум кога барањето е одобрено од раководителот на Тимот",
  vacation_title_desc: "Наслов на годишниот одмор",
  copy_tag: "Копирај ознака",
  upload_annual_leave_template: "Поставете образец за годишен одмор",
  upload_paid_holidays_template: "Поставете образец за платен одмор",
  upload_work_from_home_template: "Поставете образец за работа од дома",
  download_template: "Превземете го образецот",
  drag_or_click_to_upload: "Кликнете овде за да прикачите или повлечете го образецот",
  how_to_make_documents: "Како да направите документи?",
  document_templates_help_1: "За да се генерираат автоматски документи за отсуства на вработените, треба да се додадат образците на самите документи.",
  document_templates_help_2: "Образците треба да содржат некои од подолу наведените клучни зборови кои Ви се потребни. Се разбира, не мора да се искористат сите клучни зборови, но најверојатно ке би бидат потребни некои од нив.",
  document_templates_help_3: "На линкот подолу можете да симнете пример за образец.",
  document_templates_help_4: "Ве молиме прикачете празен .docx документ доколку немате намера да искористите некој образец.",
  download_example_template: "Симни образец",
  help: "Помош",
  not_uploaded_annual_leave_template: "Образецот за годишен одмор не е поставен",
  not_uploaded_paid_holidays_template: "Образецот за платен одмор не е поставен",
  not_uploaded_work_from_home_template: "Образецот за работа од дома не е поставен",
  company: "Фирма",
  document_templates: "Обрасци за документи",
  document_templated_uploads: "Прикачување на обрасци за документи",
  tags: "Ознаки",
  tags_description: "Опис на ознаки",
  template_successfully_uploaded: "Образецот успешно беше прикачен",
  upload_failed: "Прикачувањето не успеа",
  copied_to_clipboard: "Ознаката е копирана!",
  departmentTranslation: {
    "Default": "Основен", 
    "Основен": "Основен", 
    "Основен": "Основен", 
  },
  teamTranslation: {
    "Default": "Основен", 
    "Основен": "Основен", 
    "Основен": "Основен", 
  },
  details: "Податоци",
  company_details: "Детали за компанијата",
  name: "Име",
  address: "Адреса",
  leader_of_default_team_and_department: "Одговорен на основен тим и основен оддел: ",
  city: "Град",
  tax_number: "Даночен број",
  enter_company_tax_number: "Внесете го даночниот број на компанијата",
  optional: "(Опционално)",
  country: "Држава",
  company_logo: "Лого на компанијата",
  change_logo: "Промени лого",
  upload_logo: "Прикачи лого",
  save: "Зачувај",
  select_country: "Избери држава",
  search: "Пребарај",
  frequent_countries: "Чести држави",
  all_countries: "Сите држави",
  manager_required: "Генералниот менаџер е задолжителен",
  name_required: "Името е задолжително",
  address_required: "Адресата е задолжителна",
  city_required: "Градот е задолжителен",
  country_required: "Државата е задолжителна",
  no_changes_to_save: "Нема промени за зачувување",
  failed_to_load_company_details: "Неуспешно вчитување на деталите за компанијата",
  company_updated_successfully: "Компанијата е успешно ажурирана",
  failed_to_update_company: "Неуспешно ажурирање на компанијата",
  validation_error: "Валидациска грешка",
  please_fill_required_fields: "Ве молиме пополнете ги задолжителните полиња",
  logo_must_be_image: "Логото мора да биде слика",
  info_title: "Инфо",
  error: "Грешка",
  success: "Успешно",
  login: {
    "join_system": "Приклучете се на нашиот систем за управување на отсуства",
    "email": "E-Пошта",
    "password": "Лозинка",
    "remember_me": "Запомни ме",
    "forgot_password": "Заборавена лозинка?",
    "2fa_code": "Внесете 2FA код",
    "resending": "Испраќање повторно...",
    "resend_code": "Испрати код повторно",
    "login": "НАЈАВИ СЕ",
    "verify": "ВЕРИФИКАЦИЈА",
    "invalid_or_expired_2fa_token": "Невалиден 2FA код.",
    "resend_failed": "Неуспешно испраќање на кодот.",
    "invalid_credentials": "Невалидни креденцијали.",
    "user_is_blocked": "Корисникот е блокиран.",
    "failed": "Неуспешно",
    "invalid_2fa": "Невалиден 2FA код.",
    "resend_failed": "Неуспешно испраќање на кодот.",
    "password_min_length": "Лозинката мора да има најмалку 8 карактери.",
    "password_uppercase": "Лозинката мора да содржи најмалку едно големо слово.",
    "password_lowercase": "Лозинката мора да содржи најмалку едно мало слово.",
    "password_number": "Лозинката мора да содржи најмалку еден број.",
    "password_special": "Лозинката мора да содржи најмалку еден специјален карактер.",
    "passwords_do_not_match": "Лозинките не се совпаѓаат.",
    "password_reset_success": "Успешно ресетирање на лозинката!",
    "user_not_found": "Корисникот не е пронајден.",
    "invalid_code": "Невалиден код.",
    "invalid_or_expired_code": "Невалиден или истечен код.",
    "email_not_verified": "E-поштата не е верификувана.",
    "user_is_blocked": "Корисникот е блокиран.",
    "code_valid": "Кодот е валиден.",
    "password_expired": "Вашата лозинка истече. Ве молиме ресетирајте ја.",
    "password_reset_email_sent": "Испратен е е-маил за ресетирање на лозинката.",
    "reset_code_sent": "Испратен е код за ресетирање.",
    "send_reset_code": "Испрати код за ресетирање",
    "back_to_login": "Назад на најава",
    "otp_timer": "OTP Тајмер",
    "verify_code": "Верификувај код",
    "reset_password": "Ресетирај лозинка",
    "new_password": "Нова лозинка",
    "confirm_password": "Потврди нова лозинка",
  },
  languages: {
    "gb": "English",
    "mk": "Македонски",
    "bg": "Български",
  },
  loginPage: "Најава",
  terms_and_conditions_title: "Правила и Услови",
};
